// Class we want data to transform into
export class Contact {
  Id: number;
  PortalId?: string;
  RelationTypeId?: number;
  FullName: string;
  EmailAddress: string;

  constructor(o?: any){
    o = o || {}; // Assign empty object if o is null then assign default values so it's easier to initialize in forms
    this.Id = o.Id || null;
    this.PortalId = o.PortalId || '';
    this.RelationTypeId = o.RelationTypeId || null;
    this.FullName = o.FullName || '';
    this.EmailAddress = o.EmailAddress || '';
  }

}

// helper function to transform data to Contact
export function toContact(value: any): Contact{
  return new Contact(value);
}